import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '@src/redux/store.ts'

export type CheckedStateType = {
  whaleChecked: boolean
  garbageChecked: boolean
  toiletChecked: boolean
  busChecked: boolean
  subwayChecked: boolean
  stairwayChecked: boolean
  rampChecked: boolean
  elevatorChecked: boolean
}

const initialState: CheckedStateType = {
  whaleChecked: false,
  garbageChecked: false,
  toiletChecked: false,
  busChecked: false,
  subwayChecked: false,
  stairwayChecked: false,
  rampChecked: false,
  elevatorChecked: false,
}

const mapBottomTabSlice = createSlice({
  name: 'mapBottomTab',
  initialState,
  reducers: {
    toggleWhaleChecked: (state, action: PayloadAction<boolean>) => {
      state.whaleChecked = action.payload
    },
    toggleGarbageChecked: (state, action: PayloadAction<boolean>) => {
      state.garbageChecked = action.payload
    },
    toggleToiletChecked: (state, action: PayloadAction<boolean>) => {
      state.toiletChecked = action.payload
    },
    toggleBusChecked: (state, action: PayloadAction<boolean>) => {
      state.busChecked = action.payload
    },
    toggleSubwayChecked: (state, action: PayloadAction<boolean>) => {
      state.subwayChecked = action.payload
    },
    toggleStairwayChecked: (state, action: PayloadAction<boolean>) => {
      state.stairwayChecked = action.payload
    },
    toggleRampChecked: (state, action: PayloadAction<boolean>) => {
      state.rampChecked = action.payload
    },
    toggleElevatorChecked: (state, action: PayloadAction<boolean>) => {
      state.elevatorChecked = action.payload
    },
  },
})

export const {
  toggleWhaleChecked,
  toggleSubwayChecked,
  toggleToiletChecked,
  toggleGarbageChecked,
  toggleBusChecked,
  toggleRampChecked,
  toggleStairwayChecked,
  toggleElevatorChecked,
} = mapBottomTabSlice.actions

export const mapBottomTabSelector = (state: RootState) => state.mapBottomTab

export default mapBottomTabSlice.reducer
